import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Product } from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { UntypedFormArray, Validators } from '@angular/forms';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'scpi-already-client-of-product',
    templateUrl: './scpi-already-client-of-product.component.html',
    styleUrls: ['./scpi-already-client-of-product.component.scss'],
    standalone: false
})
export class ScpiAlreadyClientOfProductComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  @ViewChild('linearVerticalStepper', { static: true })
  private steper: MatStepper;
  products: Product[] = [];
  currentPageNumber: number = 0;
  itemsPerPage: number = 1;
  productIds: number[] = [];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.products = pledge?.products;
    this.initForm(pledge?.products);

    this.scpis.controls.forEach((scpiControl, index) => {
      scpiControl.valueChanges.subscribe(scpi => {
        if (
          this.scpis.controls[index]
            .get('parameters')
            .get('alreadyClientOfProduct').value
        ) {
          this.scpis.controls[index]
            .get('parameters')
            .get('clientIdentifiantForProduct')
            .setValidators([Validators.required]);
          this.scpis.controls[index]
            .get('parameters')
            .get('clientIdentifiantForProduct')
            .updateValueAndValidity();
        } else {
          this.scpis.controls[index]
            .get('parameters')
            .get('clientIdentifiantForProduct')
            .setValidators([Validators.nullValidator]);
          this.scpis.controls[index]
            .get('parameters')
            .get('clientIdentifiantForProduct')
            .updateValueAndValidity();
        }
      });
    });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.extract();

    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber == this.products.length - 1
    )
      this.subscriptionFacade.submitPledge(this, 'products');
    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber < this.products.length - 1
    ) {
      this.nextStep();
      // this.subscriptionFacade.submitPledge(
      //   this,
      //   'products',
      //   false,
      //   this.nextStep.bind(this),
      //   true,
      // );
    }
  }
  prev() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
    this.steper.previous();
  }
  nextPage() {
    this.currentPageNumber++;
  }

  nextStep() {
    this.currentPageNumber++;
    this.steper.next();
    this.steper.selected.completed = true;
  }
  prevStep() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
      this.steper.previous();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
  }
  stepClick(ev) {
    this.currentPageNumber = ev.selectedIndex;
  }

  get scpis() {
    return this.form.get('scpis') as UntypedFormArray;
  }
}
